import { PagePreloaderComponent } from '../../shared/ui';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { TopLevelComponent } from '../../shared';
import { Store, StoreHelper, UserService } from '../../shared/services';
import {LocationInvoiceDetail, LocationSaleDetailsService} from '../shared';

import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'location-sale-details',
    styles: [require('./location-sale-details.component.scss')],
    template: require('./location-sale-details.component.pug')
})
export class LocationSaleDetailsComponent extends TopLevelComponent implements OnInit, OnDestroy {
    @ViewChild(PagePreloaderComponent) preloader;

    locationInvoicesDetails: Array<LocationInvoiceDetail> = [];

    private _invoicesSubs: Subscription;
    private locationName: string;

    constructor(
        private _locationSaleDetailsService: LocationSaleDetailsService,
        store: Store,
        storeHelper: StoreHelper,
        userService: UserService) {
        super(store, storeHelper, userService);

        let that = this;
        let storeState = this.store.getState();

        this.locationName = storeState.locationInvoiceDetailFilter.locationSale.name;
        this.headerTitle = this.locationName;

        this._invoicesSubs = this._locationSaleDetailsService.getListInvoiceByLocation(storeState.locationInvoiceDetailFilter)
            .subscribe(data => {
                this.locationInvoicesDetails = data;
                that.preloader.hide();
            });
    }

    ngOnInit() {
        this.preloader.show();
    }

    ngOnDestroy() {
        this._invoicesSubs.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/location/location-sale-details/location-sale-details.component.ts